import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

import ActionButton from 'src/components/ActionButton.js';
import LoginIcon from '../../../../components/LoginIcon'
import Logo from '../../../../components/Logo';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { listFontStyle } from 'src/content/shared/CommonFontSize';
import log from 'loglevel';
import useAuth from '../../../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import OtpConfirm from './OtpConfirm';
import EmailLogin from './EmailLogin';

const LoginAmplify = () => {
  const { login } = useAuth();
  const [isopen, setIsopen] = useState(true);
  const [email, setEmail] = useState('');

  const [user, setUser] = useState({});
  const [step, setStep] = useState(0);
  const sessionRequestedPath = sessionStorage.getItem("requestedPath");
  const [customNoti, setCustomNoti] = useState({});

  const { t } = useTranslation();

  const handleLogin = async () => {
    try {
      await login();
    } catch (err) {
      log.info("error occured in handle login")
    }
  };


  const handleClose = () => { setIsopen(false) };
  const handleShowEmailOption = () => {
    setStep(1);
  }
  return (
    < >
      <Dialog
        open={isopen && sessionRequestedPath == null}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        sx={{ backdropFilter: "blur(5px)", }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { width: '355px', height: '290px', borderRadius: '2px', backgroundColor: '#2C314C', } }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ ...listFontStyle, fontWeight: "700", top: '16px', left: '16px' }}
        >
          Warning <br /><br />
          The use of this system is restricted to authorised government purposes only.
        </DialogTitle>
        <DialogContent sx={{ overflowY: 'hidden' }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ ...listFontStyle, }}
          >
            Any unauthorised access and use of this computer is prohibited and may be subject to criminal prosecution under the Computer Misuse Act.
            The Singapore Government reserves the right to monitor its use as necessary to ensure data security, availability and system stability.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <ActionButton
            handleClick={() => handleClose()}
            label='I understand'
            buttonStyle={{ width: '150px', margin: '10px' }}
          />

        </DialogActions>
      </Dialog>
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        <Box sx={{ width: '100%', height: '35.52px', top: '0px' }} />
        <Box
          sx={{
            width: '30%',
            height: '700px',
            bottom: '0px'
          }}
        >
          <LoginIcon />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0px',
            gap: '128px',
            position: 'absolute',
            width: '568px',
            height: '449.3px',
            left: '33%',
            right: '40%',
            bottom: '27%'
          }}
        >

          <Logo />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '0px',
              gap: '16px',
              position: 'absolute',
              width: '568px',
              height: '78px',
              top: step === 0 ? '173.3px' : '160px'
            }}
          >
            <Typography
              align="center"
              sx={{
                width: '511px',
                height: '36px',
                fontWeight: '700',
                fontSize: '32px',
                lineHeight: '36px',
                color: '#FFFFFF',
              }}
            >
              {/* // release-ship branch
              {t('Welcome to CVX')}
              */}
              {step !== 2 ? t('Welcome to Sirius') : t('Login')}
            </Typography>
            {step !== 2
              && (
                <Typography
                  align="center"
                  sx={{
                    whiteSpace: 'nowrap',
                    flexWrap: 'nowrap',
                    width: '610px',
                    height: '26px',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '26px',
                    color: "#E6E7EB",
                    opacity: 0.5,
                  }}
                >
                  {t("Connecting Agencies through video exchanges across Singapore")}
                </Typography>
              )}
          </Box>

          {step === 0
            && (
              <>
                <Button
                  sx={{
                    //flexDirection: 'row',
                    justifyContent: 'center',
                    //order: 1,
                    width: '359px',
                    height: '70px',
                    top: '128px',
                    background: '#6378CA',
                    borderRadius: '2px',
                    '&:hover': {
                      background: '#3D58BD'
                    }
                  }}
                  onClick={handleLogin}
                  color="primary"
                  size="large"
                  variant="contained"
                >
                  <Typography
                    sx={{
                      whiteSpace: 'nowrap',
                      flexWrap: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'center',
                      height: '26px',
                      fontWeight: '700',
                      fontSize: '20px',
                      lineHeight: '26px',
                      color: '#FFFFFF'
                    }}
                  >
                    Log in using your SSO credentials
                  </Typography>
                </Button>

                <Typography Typography
                  onClick={handleShowEmailOption}
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: 'white',
                    marginTop: '10px',
                    cursor: 'pointer',
                    '&:hover': { color: '#3D58BD', textDecoration: 'underline' },
                    textDecoration: 'underline',
                  }}
                >
                  Use Email OTP to log in
                </Typography>
              </>
            )
          }

          {step === 1 && (
            <EmailLogin
              email={email}
              setEmail={setEmail}
              setUser={setUser}
              setStep={setStep}
              customNoti={customNoti}
              setCustomNoti={setCustomNoti}
              handleLogin={handleLogin}
            />
          )}
          {step === 2 && (
            <OtpConfirm
              step={step}
              setStep={setStep}
              user={user}
              setUser={setUser}
              email={email}
              customNoti={customNoti}
              setCustomNoti={setCustomNoti}
            />

          )}
        </Box>

        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '54.72px', width: '100%', background: 'black', position: 'absolute', bottom: '0px' }}>
          <Typography style={{ fontSize: '14px', padding: '15px' }}>
            Report Vulnerability <IconButton size='small'><OpenInNewIcon fontSize='small' /> </IconButton> Privacy Terms of Use
          </Typography>
          <Typography style={{ fontSize: '14px', padding: '15px' }}>
            &copy; 2022 Government of Singapore. Last Updated 24 Jun 2022
          </Typography>
        </Box>
      </Box >
    </ >
  );
};

export default LoginAmplify;
